import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [ProfileComponent, ChangePasswordComponent, ResetPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProfileRoutingModule,
    NgcCookieConsentModule,
    SharedModule
  ],
})
export class ProfileModule { }
